import React, { ReactNode } from 'react';

import ContactButtons from '../ContactButtons';
import { Header, Title, BackButton, BackIcon, UserCheckIcon } from './styles';

type Props = {
  title: string;
  children: ReactNode;
  icon?: ReactNode;
  withContactButtons?: boolean;
  onBack?: () => void;
};

const TripCardHelp = ({ title, children, icon, withContactButtons = false, onBack }: Props) => (
  <div>
    <Header>
      {onBack && (
        <BackButton onClick={onBack}>
          <BackIcon width={16} />
        </BackButton>
      )}
      <div>
        {icon ? icon : <UserCheckIcon />}
        <Title>{title}</Title>
      </div>
    </Header>
    {children}
    {withContactButtons && <ContactButtons />}
  </div>
);

export default TripCardHelp;
